import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import * as $ from 'jquery';
import { PosesListComponent } from './poses-list.component';
import { PosesService } from './poses.service';
import { IPos } from './pos';
import * as myGlobals from './../global';
import { Observable } from 'rxjs/Observable';
import { ISucursal } from '../sucursales/sucursal';
import { SucursalesService } from '../sucursales/sucursales.service';
import {RuteosService} from '../ruteo/ruteos.service';
import { errorMessageFromAjax } from '../services/ajax-error';

@Component({
  selector: 'pm-edit-pos',
  templateUrl: './edit-pos.component.html',
  styleUrls: ['./edit-pos.component.sass'],
  providers: [PosesService]
})
export class EditPosComponent implements OnInit, OnDestroy, AfterViewInit {
  poses: IPos[] = [];
  errorMessage = '';
  pos: IPos;
  posIdentifierSelected: string;
  pinPadIdentifierSelected: string;
  merchantSelected: string;
  statusSelected: string;

  merchantList: Observable<ISucursal[]> = this.merchantService.getMerchants();

  constructor(
    public service: PosesService,
    private parent: PosesListComponent,
    private merchantService: RuteosService
  ) {}

  ngOnInit() {
    console.log('EditPosComponent: OnInit: id: ', this.parent.editnumber);
    this.getPos(this.parent.editnumber);
  }

  ngAfterViewInit() {
    $('a[rel=pos]').addClass('selected');
  }

  edit(elemento): boolean {
    console.log('edit:' + elemento.parent.editnumber);
    const formData = {
      posIdentifier: $('input[name=posIdentifier]').val(), // 00083000,
      pinPadIdentifier: $('input[name=pinPadIdentifier]').val(), // 00083000,
      merchantId: $('#merchantId option:selected').val(), // 210,
      status: $('#status option:selected').val() // 1
    };
    console.log('edit: formData: ', formData);

    const parentRef = this.parent;

    $.ajax({
      url: myGlobals.baseApi + '/webadmin/v1/point-of-sale/' + elemento.parent.editnumber,
      dataType: 'json',
      headers: {
        sessionToken: localStorage.getItem('sessionToken')
      },
      contentType: 'application/json; charset=utf-8',
      type: 'PUT',
      data: JSON.stringify(formData)
    }).done(function(response) {
      console.log('delete sucess!!');
      parentRef.showPoses = true;
      parentRef.showAddPos = false;
      parentRef.showEditPos = false;
    }).fail(function(jqXHR) {
      alert('No se pudo actualizar el punto de venta: ' + errorMessageFromAjax(jqXHR));
    });
    return false;
  }

  getPos(id: number): any {
    console.log('id: ', id);
    this.service.getPos(id).subscribe(
      res => {
        this.pos = res;
        this.posIdentifierSelected = res.posIdentifier;
        this.pinPadIdentifierSelected = res.pinPadIdentifier;
        this.merchantSelected = res.merchantId;
        this.statusSelected = res.status;
        console.log('EditPosComponent: getPos: posIdentifierSelected: [', this.posIdentifierSelected, ']');
        console.log('EditPosComponent: getPos: pinPadIdentifierSelected: [', this.pinPadIdentifierSelected, ']');
        console.log('EditPosComponent: getPos: merchantSelected: [', this.merchantSelected, ']');
        console.log('EditPosComponent: getPos: statusSelected: [', this.statusSelected, ']');
      },
      error => (this.errorMessage = error as any)
    );
  }

  cancelPos(): void {
    this.parent.showPoses = true;
    this.parent.showAddPos = false;
    this.parent.showEditPos = false;
  }

  ngOnDestroy() {
    $('a[rel=pos]').removeClass('selected');
  }
}
